// @flow
import JQueryView, { on, removeInvalidFeedback } from '../../common/JQueryView';
import {
  RESOLUTION_CHOICE_CATEGORY,
  RESOLUTION_OTHER_CATEGORY,
  RESOLUTION_RELATED_SO_CATEGORY,
} from '../../../models/ResolutionCategory';

import { REPORT_OTHER_CATEGORY } from '../../../models/ReportCategory';
import { resolutionContentTemplates } from '../../../models/resolutions/ContentTemplate';
import { anotherPaperTemplates } from '../../../models/another_papers/anotherPaperTemplate';
import DateRangePicker from '../../common/DateRangePicker';
import dayjs from 'dayjs';

declare var $: any;

export default class ReportView extends JQueryView {
  constructor() {
    super('.company.stockholder_meetings.report');
    this.render();
  }

  @on({ event: 'click', selector: '.remove_fields' })
  onClickRemoveFields(event: any) {
    $(event.target)
      .prev('input[type=hidden]')
      .val('1');
    $(event.target)
      .closest('fieldset')
      .hide();
    event.preventDefault();
    this.showConvocationPaperForm();
    this.updatePreview();
  }

  @on({ event: 'click', selector: '.add_fields' })
  onClickAddFields(event: any) {
    const time = new Date().getTime();
    const regexp = new RegExp($(event.target).data('id'), 'g');
    event.preventDefault();
    $(event.target).before(
      $(event.target)
        .data('fields')
        .replace(regexp, time),
    );
    this.render();
    this.updatePreview();
  }

  @on({ event: 'change', selector: '.resolution_select' })
  onChangeResolutionSelect(event: any) {
    this.showResolutionForm($(event.target));
    this.inputResolutionContentWithTemplate($(event.target));
    this.showConvocationPaperForm();
    this.updatePreview();
  }

  @on({ event: 'change', selector: '.report_select' })
  onChangeReportSelect(event: any) {
    this.showReportForm($(event.target));
    this.updatePreview();
  }

  @on({ event: 'change', selector: '.convocation_paper_select' })
  onChangeConvocationPaperSelect(event: any) {
    this.inputConvocationPaperContentWithTemplate($(event.target));
    this.updatePreview();
  }

  @on({ event: 'keyup', selector: '.daterange-picker' })
  onKeyupDaterangePicker(event: any) {
    $(event.target).val(
      $(event.target)
        .val()
        .replace(/[^0-9-]/g, ''),
    );
  }

  @on({ event: 'change', selector: '.daterange-picker' })
  onChangeDaterangePicker() {
    console.log('onChangeDaterangePicker');
    this.updatePreview();
  }

  @on({ event: 'change', selector: '.report_other' })
  onChangeReportOther() {
    this.updatePreview();
  }

  @on({ event: 'change', selector: '.resolution-content' })
  onChangeResolutionContent() {
    this.updatePreview();
  }

  @on({ event: 'change', selector: '.convocation-paper-content' })
  onChangeConvocationPaperContent() {
    this.updatePreview();
  }

  @on({ event: 'change', selector: '.resolution-choice' })
  onChangeResolutionChoice() {
    this.updatePreview();
  }

  @on({ event: 'change', selector: '.resolution_other' })
  onChangeResolutionOther() {
    this.updatePreview();
  }

  @on({ event: 'change', selector: '.form-control' })
  onChangeFormControl(event: any) {
    const target = $(event.target);
    if (target.val().length !== 0) {
      target.find('.form-control').addClass('form-control-active');
      target.removeClass('is-invalid');
      removeInvalidFeedback(target);
      target.removeClass('focus');
    }
  }

  @on({ event: 'click', selector: '.input-group-append' })
  onClickAppend(event: any) {
    $(event.target)
      .parents('.input-group')
      .children('input,.daterange-picker')
      .focus();
  }

  initDateRangePicker(container: any) {
    new DateRangePicker(
      container,
      {
        singleDatePicker: true,
        datePicker: true,
        timePicker: false,
        showDropdowns: true,
        maxDate: dayjs(),
        locale: {
          format: 'Y-MM-DD',
        },
      },
      {
        picker: {
          format: {
            start: 'Y-MM-DD',
            template: startDate => startDate,
          },
        },
      },
    ).render();
  }

  showReportForm(select: any) {
    const select_val = Number(select.val());
    const otherForm = select.parent().next();

    if (REPORT_OTHER_CATEGORY.includes(select_val)) {
      otherForm.show();
    } else {
      otherForm.hide();
    }
  }

  showResolutionForm(select: any) {
    const select_val = Number(select.val());
    const representativeForm = select.parent().next();
    const otherForm = representativeForm.next();

    if (RESOLUTION_CHOICE_CATEGORY.includes(select_val)) {
      representativeForm.show();
      otherForm.hide();
    } else if (RESOLUTION_OTHER_CATEGORY.includes(select_val)) {
      otherForm.show();
      representativeForm.hide();
    } else {
      otherForm.hide();
      representativeForm.hide();
    }
  }

  inputResolutionContentWithTemplate(select: any) {
    const select_val = Number(select.val());
    const contentForm = select
      .parents('.resolution-field')
      .find('textarea.resolution-content');
    const template = resolutionContentTemplates.find(
      t => t.resolutionCategoryId === select_val,
    );

    if (template !== undefined) {
      contentForm.val(template['content']);
    } else {
      contentForm.val('');
    }
  }

  // SO関連議案を選択した場合のみ、別紙欄を表示する対応
  showConvocationPaperForm() {
    const selectedCategories = [];
    $('.resolution_select:visible').each((i, a) => {
      const select_val = Number($(a).val());
      selectedCategories.push(select_val);
    });
    const isIncludedSoCategory = RESOLUTION_RELATED_SO_CATEGORY.some(
      soCategory => selectedCategories.includes(soCategory),
    );
    if (isIncludedSoCategory) {
      $('#convocation_paper_form').show();
    } else {
      $('#convocation_paper_form').hide();
    }
  }

  inputConvocationPaperContentWithTemplate(select: any) {
    const select_val = Number(select.val());
    const contentForm = select
      .parents('.convocation-paper-field')
      .find('textarea.convocation-paper-content');
    const nameForm = select
      .parents('.convocation-paper-field')
      .find('input.convocation-paper-name');

    const template = anotherPaperTemplates.find(t => t.id === select_val);

    if (template !== undefined) {
      nameForm.val(template['name']);
      contentForm.val(template['content']);
    } else {
      nameForm.val('');
      contentForm.val('');
    }
  }

  updatePreview() {
    $('.simple_form').attr('data-remote', 'true');
    $('#preview_button').click();
    $('.simple_form').attr('data-remote', 'false');
  }

  initAdjustResolutionTextArea = () => {
    const targets = $('textarea');
    if (targets.length) {
      for (let i = 0; i < targets.length; i++) {
        targets[i].style.height = 'auto';
        targets[i].style.height = targets[i].scrollHeight + 'px';
      }
    }
  };

  // 決議事項のセレクトメニューにオプションとしてコメントを追加する
  initAddCommentOptionToResolutionSelect = () => {
    $('.resolution_select').each(function(_, element) {
      let shouldAddOption: boolean = true;
      let firstCommentIndex: number = 0;
      let secondCommentIndex: number = 0;

      // セレクトメニューにコメントのオプションを追加する必要があるか、追加する場合はどの位置に追加するか判定
      $(`#${$(this)[0].id} option`).each(function(i, v) {
        switch (v.value) {
          // 既にoptionが追加されているか判定
          case 'comment1':
            shouldAddOption = false;
            break;
          // 1つ目のコメントの挿入位置を判定
          // 「役員報酬改定の件」の下に挿入
          case '17':
            firstCommentIndex = i;
            break;
          // 2つ目のコメントの挿入位置を判定
          // 「その他」の上に挿入
          case '11':
            secondCommentIndex = i;
            break;
          default:
            break;
        }
      });

      if (shouldAddOption === true) {
        let comment1 = document.createElement('option');
        let comment2 = document.createElement('option');

        comment1.value = 'comment1';
        comment2.value = 'comment2';
        comment1.text =
          'ーーー以下の議案は取締役会設置会社向けの参考文付き議案ですーーー';
        comment2.text =
          'ーーー上記以外の議案を追加するにはその他を選択してくださいーーー';

        element.add(comment1, firstCommentIndex);
        // 1つ目のoptionが追加されるためindexを+1している
        element.add(comment2, secondCommentIndex + 1);
      }
    });
  };

  render() {
    $('.resolution_select').each((i, a) => {
      this.showResolutionForm($(a));
    });
    $('.report_select').each((i, a) => {
      this.showResolutionForm($(a));
    });
    this.showConvocationPaperForm();
    this.updatePreview();
    $('textarea').on('input', function() {
      this.style.height = 'auto';
      this.style.height = this.scrollHeight + 'px';
    });
    this.initAdjustResolutionTextArea();
    this.initDateRangePicker(this.$el);
    this.initAddCommentOptionToResolutionSelect();
  }
}
